import { render, staticRenderFns } from "./ChevronLeft.vue?vue&type=template&id=3a552db1&scoped=true"
import script from "./ChevronLeft.vue?vue&type=script&lang=js"
export * from "./ChevronLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a552db1",
  null
  
)

export default component.exports